import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { IIcon } from '../icon/icon.component';
import { IChat } from '../../services/chat/chat.data';

@Component({
  selector: 'i2g-chat-list',
  templateUrl: 'chat-list.component.html',
  styleUrls: ['chat-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatListComponent implements OnInit {
  @Input() chats: List<IChat>;
  @Input() emptyStateIcon: IIcon;
  @Input() emptyStateDescription: string;

  constructor() {}

  ngOnInit() {}
}
